import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import axios from 'axios';
import ResolvedRegistrationModal from '@/components/ResolvedRegistrationModal.vue';
import { Notification } from '@/core/interfaces/notification';
import { ResolvedRegistration } from '@/core/interfaces/resolvedRegistration';
import { Ticket } from '@/core/interfaces/ticket';
import TimeRegistrationModal from '@/components/TimeRegistrationModal.vue';
import { TimeRegistration } from '@/core/interfaces/timeRegistration';

@Component
export default class OpensResolvedRegistrationModal extends Vue {
    openTimeRegistrationModal(from?: {
        notification?: Notification;
        ticket?: Ticket;
    }, timeRegistration?: TimeRegistration): Promise<void> {
        return new Promise((resolve) =>
            this.$modal.show(
                TimeRegistrationModal,
                {
                    timeRegistration,
                    from,
                    locked: !!timeRegistration,
                },
                { adaptive: true, height: '90%', width: '700px', focusTrap: true },
                {
                    'before-close': () => {
                        document.documentElement.style.overflow = 'auto';
                        resolve();
                    },
                },
            ));
    }

    async openResolvedRegistrationModal(
        shouldConfirm: boolean,
        from?: { notification?: Notification; ticket?: Ticket },
    ): Promise<void> {
        if (shouldConfirm) {
            const confirm = await this.$bvModal.msgBoxConfirm(
                'Do you want to log the solution?',
                {
                    centered: true,
                    size: 'sm',
                    bodyClass: 'font-weight-bold',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                },
            );

            if (!confirm) {
                return;
            }
        }

        let registration: ResolvedRegistration | null = null;
        let locked = false;

        if (from) {
            const entity = from.notification ?? from.ticket;
            const existingId = entity?.resolved_registration_id;
            locked =
                entity?.resolved_registration_locked ||
                (entity?.resolved_registration_id &&
                    entity?.resolved_registration_user_id !==
                    this.$store.getters.currentUserId) ||
                false;

            registration = existingId
                ? (await axios.get(`resolved-registrations/${existingId}`)).data
                : null;
        }

        document.documentElement.style.overflow = 'hidden';

        return new Promise((resolve) =>
            this.$modal.show(
                ResolvedRegistrationModal,
                { registration, locked, ...from },
                {
                    adaptive: true,
                    height: '95%',
                    width: '700px',
                    focusTrap: true,
                },
                {
                    'before-close': () => {
                        document.documentElement.style.overflow = 'auto';
                        resolve();
                    },
                },
            ),
        );
    }
}
